var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            "label-position": "top",
            rules: _vm.rules,
            "label-width": "120px",
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _vm.isEdit
                        ? _c("BjLogButton", {
                            attrs: {
                              id: _vm.form.id,
                              permission: "BusinessChannelOnlineCsgList_Log",
                              title: _vm.form.name,
                              api: "channelApi",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(_vm._s(_vm.$t("ChannelManagement.new.title")) + " ")]
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ChannelManagement.new.Channel"),
                    prop: "channelTypeCode",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "lov-code": "SCHL.CHANNEL_TYPE",
                      disabled: _vm.isEdit,
                    },
                    on: { change: _vm.getChannelName },
                    model: {
                      value: _vm.form.channelTypeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelTypeCode", $$v)
                      },
                      expression: "form.channelTypeCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ChannelManagement.csg.name"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.channelTypeCode === "1"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: "",
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.project"
                            ),
                            prop: "distributionCenterId",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.distributionCenterId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "distributionCenterId", $$v)
                              },
                              expression: "form.distributionCenterId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ChannelManagement.Header.empower"),
                            prop: "authorization",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.authorization,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "authorization", $$v)
                              },
                              expression: "form.authorization",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.authAccount"
                            ),
                            prop: "refreshToken",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.refreshToken,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "refreshToken", $$v)
                              },
                              expression: "form.refreshToken",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "3"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Client ID", prop: "appKey" } },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Client Secret", prop: "appSecret" },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.thr"),
                                prop: "distributionCenterType",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.CANG_LIST },
                                on: { change: _vm.changeKu },
                                model: {
                                  value: _vm.form.distributionCenterType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "distributionCenterType",
                                      $$v
                                    )
                                  },
                                  expression: "form.distributionCenterType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit && _vm.form.distributionCenterType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.two"),
                                prop: "cangCenterName",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.KU_LIST },
                                on: { change: _vm.chooseCenter },
                                model: {
                                  value: _vm.form.cangCenterName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cangCenterName", $$v)
                                  },
                                  expression: "form.cangCenterName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getRemarks()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChannelManagement.Header.api"))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "ChannelManagement.Header.api"
                              ),
                              disabled: "",
                              type: "textarea",
                              "show-word-limit": "",
                              autosize: "",
                            },
                            model: {
                              value: _vm.ShopifyRemarks,
                              callback: function ($$v) {
                                _vm.ShopifyRemarks = $$v
                              },
                              expression: "ShopifyRemarks",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.form.channelTypeCode === "5"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.wooCommerce.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.wooCommerce.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.wooCommerce.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "6"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.magento.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.magento.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.magento.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.magento.bpCode"
                            ),
                            prop: "bpCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: { clearable: "", disabled: _vm.isEdit },
                            model: {
                              value: _vm.form.bpCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bpCode", $$v)
                              },
                              expression: "form.bpCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "7"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ChannelManagement.csg.cin7.appKey"),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.cin7.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "8"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.appKeyNew"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.bpCode"
                            ),
                            prop: "bpCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.form.distributionCenterId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "distributionCenterId", $$v)
                              },
                              expression: "form.distributionCenterId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "11"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.maropost.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "12"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "13"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.channelAdvisor.authAccount"
                            ),
                            prop: "refreshToken",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.refreshToken,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "refreshToken", $$v)
                              },
                              expression: "form.refreshToken",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "consumerKey", prop: "consumerKey" },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.consumerKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "consumerKey", $$v)
                              },
                              expression: "form.consumerKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "consumerSecret",
                            prop: "consumerSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.consumerSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "consumerSecret", $$v)
                              },
                              expression: "form.consumerSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "19"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.cin7Core.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.cin7Core.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.cin7.apiServiceUrl"
                            ),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ChannelManagement.csg.cin7.bpCode"),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.form.bpCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bpCode", $$v)
                              },
                              expression: "form.bpCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "20"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appKey"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appSecret"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "consumerKey", prop: "consumerKey" },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.consumerKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "consumerKey", $$v)
                              },
                              expression: "form.consumerKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "consumerSecret",
                            prop: "consumerSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.consumerSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "consumerSecret", $$v)
                              },
                              expression: "form.consumerSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "21"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appKey1"
                            ),
                            prop: "appKey",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.appSecret1"
                            ),
                            prop: "appSecret",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.thr"),
                                prop: "distributionCenterType",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.CANG_LIST },
                                on: { change: _vm.changeKu },
                                model: {
                                  value: _vm.form.distributionCenterType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "distributionCenterType",
                                      $$v
                                    )
                                  },
                                  expression: "form.distributionCenterType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit && _vm.form.distributionCenterType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.two"),
                                prop: "cangCenterName",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.KU_LIST },
                                on: { change: _vm.chooseCenter },
                                model: {
                                  value: _vm.form.cangCenterName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cangCenterName", $$v)
                                  },
                                  expression: "form.cangCenterName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getRemarks()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChannelManagement.Header.api"))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "ChannelManagement.Header.api"
                              ),
                              disabled: "",
                              type: "textarea",
                              "show-word-limit": "",
                              autosize: "",
                            },
                            model: {
                              value: _vm.LIXINGRemarks,
                              callback: function ($$v) {
                                _vm.LIXINGRemarks = $$v
                              },
                              expression: "LIXINGRemarks",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.form.channelTypeCode === "22"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Client ID", prop: "appKey" } },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Client Secret", prop: "appSecret" },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.thr"),
                                prop: "distributionCenterType",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.CANG_LIST },
                                on: { change: _vm.changeKu },
                                model: {
                                  value: _vm.form.distributionCenterType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "distributionCenterType",
                                      $$v
                                    )
                                  },
                                  expression: "form.distributionCenterType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit && _vm.form.distributionCenterType == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("ChannelManagement.Header.two"),
                                prop: "cangCenterName",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "option-list": _vm.KU_LIST },
                                on: { change: _vm.chooseCenter },
                                model: {
                                  value: _vm.form.cangCenterName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "cangCenterName", $$v)
                                  },
                                  expression: "form.cangCenterName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getRemarks()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChannelManagement.Header.api"))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "ChannelManagement.Header.api"
                              ),
                              disabled: "",
                              type: "textarea",
                              "show-word-limit": "",
                              autosize: "",
                            },
                            model: {
                              value: _vm.ShopifyRemarks,
                              callback: function ($$v) {
                                _vm.ShopifyRemarks = $$v
                              },
                              expression: "ShopifyRemarks",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.form.channelTypeCode === "23"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "AppKey", prop: "appKey" } },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "AppSecret", prop: "appSecret" } },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.form.channelTypeCode === "24"
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Client ID", prop: "appKey" } },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Client Secret", prop: "appSecret" },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.appSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appSecret", $$v)
                              },
                              expression: "form.appSecret",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "ChannelManagement.csg.shopify.apiServiceUrl"
                            ),
                            prop: "apiServiceUrl",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.REMARK,
                            },
                            model: {
                              value: _vm.form.apiServiceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "apiServiceUrl", $$v)
                              },
                              expression: "form.apiServiceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "main-btn",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.getRemarks()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChannelManagement.Header.api"))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "ChannelManagement.Header.api"
                              ),
                              disabled: "",
                              type: "textarea",
                              "show-word-limit": "",
                              autosize: "",
                            },
                            model: {
                              value: _vm.ShopifyRemarks,
                              callback: function ($$v) {
                                _vm.ShopifyRemarks = $$v
                              },
                              expression: "ShopifyRemarks",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          !["4", "23"].includes(_vm.form.channelTypeCode)
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.startDate"),
                        prop: "orderStartTime",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          disabled: !_vm.$store.getters.cusId || _vm.isEdit,
                          format: "dd/MM/yyyy HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetime",
                          "picker-options": _vm.pickerOptions,
                          placeholder: _vm.$t("billingPage.startDate"),
                        },
                        model: {
                          value: _vm.form.orderStartTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderStartTime", $$v)
                          },
                          expression: "form.orderStartTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.$store.getters.cusId
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "ChannelManagement.csg.channelAdvisor.WhetherGoods"
                                      )
                                    ) +
                                    " "
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      placement: "top-start",
                                      content: _vm.$t(
                                        "ChannelManagement.csg.channelAdvisor.PleaseNote"
                                      ),
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-question" })]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3277636188
                      ),
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.needInsurance,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "needInsurance", $$v)
                          },
                          expression: "form.needInsurance",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          ["3", "22"].includes(_vm.form.channelTypeCode) &&
          !_vm.$store.getters.cusId
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "ExternalPlatformProducts.inventory"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        709533529
                      ),
                    },
                    [
                      _c("el-switch", {
                        attrs: { "inactive-value": 0, "active-value": 1 },
                        model: {
                          value: _vm.form.isStockSync,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isStockSync", $$v)
                          },
                          expression: "form.isStockSync",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          ["3", "22"].includes(_vm.form.channelTypeCode)
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("ExternalPlatformProducts.Capture")
                                    ) +
                                    " "
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      placement: "top",
                                      content: _vm.$t(
                                        "ExternalPlatformProducts.CaptureTip"
                                      ),
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-question" })]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1244945475
                      ),
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.isWriteBackCapture,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isWriteBackCapture", $$v)
                          },
                          expression: "form.isWriteBackCapture",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }